import { axios, AxiosError, AxiosResponse, Method } from '@/config/plugins/axios';
import { FormValue } from '@/functions/getFormValue';
import { Export } from '@/types';

export const PROJECT_URL = '/api/projects';

export function sendProject(method: Method, url: string, formValue: FormValue, ref: any) {
	ref.setLoading(true);

	axios({ method, url, data: formValue })
		.then(() => {
			// this.successMsg = this.$t('views.createPassword.successMsg') as string;
			ref.close();
			ref.$emit('sent');
		})
		.catch((error: AxiosError) => {
			if (!error.response) {
				return;
			}

			const data = error.response.data;

			if (data.errors?.children) {
				ref.setErrors(data.errors.children);
			}
		})
		// Stop loading
		.finally(() => ref.setLoading(false));
}

/**
 * Gère les projets.
 */
export function fetchProject(projectToken: string): Promise<AxiosResponse<any>> {
	return axios.get(`/api/projects/${projectToken}`);
}

export function cancelProjectApiFile(projectToken: string, item: Export) {
	return axios.delete(`/api/projects/${projectToken}/exports/${item.id}/cancel`);
}

export function deleteProjectApiFile(projectToken: string, item: Export) {
	return axios.delete(`/api/projects/${projectToken}/exports/${item.id}`);
}
